module.exports = __webpack_public_path__ + "media/flags/vu-824ff41c.svg";